import { environment } from 'src/environment';
import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import * as $ from 'jquery';
import { NgFor, NgIf } from '@angular/common';
import { ReadMoreComponent } from '../read-more';

@Component({
  selector: 'app-device-accordion',
  templateUrl: './device-accordion.component.html',
  styleUrls: ['./device-accordion.component.scss'],
  standalone: true,
  imports: [NgFor, NgIf, ReadMoreComponent],
})
export class DeviceAccordionComponent implements OnInit {

  @Input() deviceType:
    {
      device_description,
      device_type,
      device_main_img,
      device_backbone_img,
      device_logo1,
      device_logo2,
      device_logo3,
      device_logo4,
      type_slug
    };
  currentDevice;
  safeURL;
  image_format = ".jpg";
  @Input() samrtTVInfo;

  skinName = environment.skinName;
  constructor(private _sanitizer: DomSanitizer) { }

  ngOnInit(): void {
  }

  update(current, device) {
    if (this.currentDevice !== device.device_name) {
      $("details[open]").not(current).removeAttr("open");
      $([document.documentElement, document.body]).animate({ scrollTop: $("#" + device.type_slug).offset().top - 100 });
      this.currentDevice = device.device_name;
    }
  }

  gotoSection(type): void {
    $("details[open]").removeAttr("open");
    this.samrtTVInfo.forEach(item => {
      if (item.type_slug === type) {
        this.currentDevice = item.device_name;
      }
    });
    $([document.documentElement, document.body]).animate({ scrollTop: $("#" + type).offset().top - 100 }, 2000);
    $("#" + type).attr('open', 'true');
  }


  getVideoURL(url) {
    return url
    // return this._sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  // onImgError(event) {
  //   event.target.src = `src/branding/theme/assets/static_assets/device-steps.svg`;
  // }

}
